import React from 'react';
import { Download, Upload, Trash2, Save } from 'lucide-react';
import { useStore } from '../../store/useStore';
import { exportSaveData, importSaveData, triggerHardReset } from '../../store/saveSystem';
import { Card } from '../common/Card';
import { Button } from '../common/Button';

export const SettingsPanel = () => {
    return (
        <Card title="Settings">
            <div className="flex flex-col gap-8 p-4">
                <section>
                    <h3 className="text-lg font-semibold text-slate-200 mb-4 border-b border-slate-700 pb-2 flex items-center gap-2">
                        <Save size={20} /> Save Management
                    </h3>
                    <div className="flex gap-4 flex-wrap">
                        <Button
                            onClick={() => {
                                const saveString = exportSaveData(useStore.getState());

                                // Create filename with timestamp
                                const now = new Date();
                                const timestamp = now.toISOString().replace(/[:.]/g, '-').slice(0, 19);
                                const filename = `idlescape-${timestamp}.sav`;

                                // Create blob and download
                                const blob = new Blob([saveString], { type: 'application/json' });
                                const url = URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                a.download = filename;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                URL.revokeObjectURL(url);

                                alert(`Save exported to ${filename}`);
                            }}
                            variant="primary"
                        >
                            <Download size={16} /> Export Save to File
                        </Button>
                        <Button
                            onClick={() => {
                                // Create hidden file input
                                const input = document.createElement('input');
                                input.type = 'file';
                                input.accept = '.sav,.json';

                                input.onchange = (e) => {
                                    const file = (e.target as HTMLInputElement).files?.[0];
                                    if (!file) return;

                                    const reader = new FileReader();
                                    reader.onload = (event) => {
                                        const saveString = event.target?.result as string;
                                        if (saveString) {
                                            const gameState = importSaveData(saveString);
                                            if (gameState) {
                                                useStore.setState(gameState);
                                                alert('Save imported successfully!');
                                                window.location.reload();
                                            } else {
                                                alert('Invalid save file! Please check the format and try again.');
                                            }
                                        }
                                    };
                                    reader.onerror = () => {
                                        alert('Failed to read save file!');
                                    };
                                    reader.readAsText(file);
                                };

                                input.click();
                            }}
                            variant="outline"
                        >
                            <Upload size={16} /> Import Save from File
                        </Button>
                    </div>
                </section>

                <section className="bg-red-950/20 p-4 rounded-lg border border-red-900/30">
                    <h3 className="text-lg font-semibold text-red-400 mb-4 border-b border-red-900/30 pb-2 flex items-center gap-2">
                        Danger Zone
                    </h3>
                    <p className="text-slate-400 text-sm mb-4">
                        Resetting will wipe all progress. This action cannot be undone.
                    </p>
                    <Button
                        variant="danger"
                        onClick={() => {
                            if (confirm('Are you sure you want to wipe your save? This will delete EVERYTHING and cannot be undone.')) {
                                triggerHardReset();
                            }
                        }}
                    >
                        <Trash2 size={16} /> Hard Reset Game
                    </Button>
                </section>
            </div>
        </Card>
    );
};
